import script from "./namaAcara.vue?vue&type=script&setup=true&lang=js"
export * from "./namaAcara.vue?vue&type=script&setup=true&lang=js"

import "./namaAcara.vue?vue&type=style&index=0&id=ab470b18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab470b18"]])

export default __exports__